import {CaregiverMode} from '../../../../../enums/caregiver-mode';
import {ActivityTimeline} from '../../../../../components/activity-timeline/activity-timeline';
import {translations} from '../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';

export default function ActivityFeedSystemAdministratorOfficeScreen() {
  const {t} = useTranslation();
  return (
    <ActivityTimeline
      headerTitle={t(translations.office.system_administrator.tabs.activity)}
      caregiverMode={CaregiverMode.SystemAdministrator}
    />
  );
}
